import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class AccordionMainContentContainerConverter extends CmsConverterService<AccordionMainContentContainerData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      background: formData.st_backgroundcolor?.value?.identifier ?? '',
      headline: formData.st_accordion_main_headline ?? defaultTextInput,
      rows: formData.st_row ?? defaultFSCatalog,
      openPanelNumber: formData.st_number?.value ?? 0
    }
  }
}

export const ACCORDION_MAIN_CONTENT_CONTAINER_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, CmsComponent>>('AccordionMainContentContainerConverter')

export interface AccordionMainContentContainerData extends ConvertedComponentData {
  rows: FsCatalog;
  headline: TextInput;
  background: string;
  openPanelNumber: number;
}
